import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, Star, ShieldCheck, ArrowRight } from "lucide-react";

const SEEN_KEY = "cm_welcome_seen";

export default function WelcomePopup() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem(SEEN_KEY) === "1") return undefined;
    const reduced = window.matchMedia
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    timerRef.current = setTimeout(() => {
      sessionStorage.setItem(SEEN_KEY, "1");
      setOpen(true);
    }, reduced ? 400 : 2600);
    return () => clearTimeout(timerRef.current);
  }, []);

  const close = () => setOpen(false);
  const goCars = () => { close(); navigate("/auto"); };

  if (!open) return null;

  return (
    <div className="cm-wp-overlay" role="dialog" aria-modal="true" data-testid="welcome-popup">
      <div className="cm-wp-backdrop" onClick={close} aria-hidden="true" />
      <div className="cm-wp-card">
        <button
          type="button"
          className="cm-wp-x"
          aria-label="Chiudi"
          onClick={close}
          data-testid="welcome-popup-close"
        >
          <X size={18} />
        </button>

        <p className="cm-wp-eyebrow">Benvenuto su Carmaps</p>
        <h3 className="cm-wp-title">Auto usate verificate,<br />controllate di persona.</h3>

        <ul className="cm-wp-stats">
          <li>
            <span className="cm-wp-ico"><Star size={16} className="fill-[var(--cm-green)] text-[var(--cm-green)]" /></span>
            <span><b>4,8 su Google</b> · +50 recensioni reali, aspettiamo anche la tua!</span>
          </li>
          <li>
            <span className="cm-wp-ico"><ShieldCheck size={16} className="text-[var(--cm-green)]" /></span>
            <span>Visione e prova organizzate su appuntamento</span>
          </li>
          <li>
            <span className="cm-wp-ico">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" />
              </span>
            </span>
            <span>Le mostriamo <b>Live su TikTok</b></span>
          </li>
        </ul>

        <button
          type="button"
          className="cm-wp-cta"
          onClick={goCars}
          data-testid="welcome-popup-cta"
        >
          Scopri le auto
          <ArrowRight size={16} />
        </button>
        <button type="button" className="cm-wp-skip" onClick={close}>
          Continua a esplorare
        </button>
      </div>
    </div>
  );
}
